export default class Room {
    constructor(name) {
        this.name = name;
        this.beds = [];
        this.services = [];
        this.favorite = false;  // hearth icon
    }
}